import {
  Box,
  Button,
  Collapse,
  HStack,
  Icon,
  SimpleGrid,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { FaChevronDown, FaChevronUp, FaSlidersH } from "react-icons/fa";
import AdditionalDataField from "./Filters/AdditionalDataField";
import AnalysisTypeFilter from "./Filters/AnalysisTypeFilter";
import DataTypeFilter from "./Filters/DataTypeFilter";
import ExcelUploadField from "./Filters/ExcelUploadField";
import QuickExplanationField from "./Filters/QuickExplanationField";

export default function AdvancedInputsSection({
  currentAnalysisTypes,
  currentDataTypes,
  excel,
  filters,
  handleApplyFilters,
  isRTL,
  requiresAdditionalData,
  t,
}) {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: false });

  return (
    <Box
      bg="gray.50"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="lg"
      p={1.5}
    >
      <VStack align="stretch" spacing={1}>
        <HStack justify="space-between" align="center"
          onClick={onToggle}
          cursor="pointer"
        >
          <HStack spacing={2}>
            <Icon as={FaSlidersH} color="blue.500" />
            <Box>
              <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                {t("reports.advancedInputs", "Advanced inputs")}
              </Text>
              <Text fontSize="xs" color="gray.500">
                {t(
                  "reports.advancedInputsDesc",
                  "Additional context and optional AI settings",
                )}
              </Text>
            </Box>
          </HStack>
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggle}
            rightIcon={<Icon as={isOpen ? FaChevronUp : FaChevronDown} />}
          >
            {isOpen ? t("general.hide", "Hide") : t("general.show", "Show")}
          </Button>
        </HStack>
        <Collapse in={isOpen} animateOpacity>
          <VStack align="stretch" spacing={1}>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
              <DataTypeFilter
                currentDataTypes={currentDataTypes}
                filters={filters}
                handleApplyFilters={handleApplyFilters}
                isRTL={isRTL}
                t={t}
              />
              <AnalysisTypeFilter
                currentAnalysisTypes={currentAnalysisTypes}
                filters={filters}
                handleApplyFilters={handleApplyFilters}
                isRTL={isRTL}
                t={t}
              />
            </SimpleGrid>
            <AdditionalDataField
              filters={filters}
              handleApplyFilters={handleApplyFilters}
              isRequired={requiresAdditionalData}
              isRTL={isRTL}
              t={t}
            />
            <QuickExplanationField
              filters={filters}
              handleApplyFilters={handleApplyFilters}
              isRTL={isRTL}
              t={t}
            />
            <ExcelUploadField
              excelData={excel.excelData}
              excelFileName={excel.excelFileName}
              handleExcelUpload={excel.handleExcelUpload}
              removeExcelFile={excel.removeExcelFile}
              t={t}
            />
          </VStack>
        </Collapse>
      </VStack>
    </Box>
  );
}
